export default __webpack_public_path__ + "static/media/navbar-icon-user.239d29e8.svg";